import FooterAccountSection from "./FooterAccountSection";

export default FooterAccountSection;
